(() => {
  'use strict';
  const esc = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const date = value => new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(value + 'T00:00:00Z'));
  const card = (a, labels) => `<article class="rg-card"><a class="rg-card-media" href="${esc(a.url)}" tabindex="-1" aria-hidden="true">${a.image ? `<img src="${esc(a.image)}" alt="" loading="lazy" width="720" height="445">` : ''}${a.format ? `<span class="rg-format-badge">${esc(a.format)}</span>` : ''}</a><div class="rg-card-body"><p class="rg-card-topic">${esc(a.topic)}</p><h3><a href="${esc(a.url)}">${esc(a.title)}</a></h3><p class="rg-card-excerpt">${esc(a.excerpt)}</p><div class="rg-card-footer"><time datetime="${esc(a.date)}">${date(a.date)}</time><a href="${esc(a.url)}" aria-label="${esc(labels.read + ': ' + a.title)}">${esc(labels.read)} ↗</a></div></div></article>`;
  const indexes = new Map();
  function index(url) {
    if (!indexes.has(url)) indexes.set(url, (async () => {
      const get = async page => {
        const endpoint = new URL(url, location.origin);
        endpoint.searchParams.set('view', 'rok-guide-index'); endpoint.searchParams.set('page', page);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) endpoint.searchParams.set('preview_theme_id', preview);
        const response = await fetch(endpoint, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Guide index unavailable');
        const data = await response.json();
        if (!Array.isArray(data.articles) || !Number.isInteger(data.pages) || data.pages > 100) throw new Error('Invalid guide index');
        return data;
      };
      const first = await get(1), articles = [...first.articles];
      for (let page = 2; page <= first.pages; page += 3) {
        const chunks = await Promise.all(Array.from({length:Math.min(3, first.pages-page+1)}, (_,i) => get(page+i)));
        chunks.forEach(chunk => articles.push(...chunk.articles));
      }
      return articles;
    })());
    return indexes.get(url);
  }
  async function library(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    try {
      const all = await index(root.dataset.blogUrl);
      if (!root.isConnected) return;
      const labels = JSON.parse(root.querySelector('[data-guide-labels]').textContent);
      const form = root.querySelector('[data-guide-search]'), search = form.querySelector('[type=search]');
      const format = root.querySelector('[data-guide-format]'), sort = root.querySelector('[data-guide-sort]');
      const grid = root.querySelector('[data-guide-grid]'), pagination = root.querySelector('[data-guide-pagination]');
      let topic = (root.dataset.currentTag || '').replace(/^Topic: /, ''), page = 1;
      const params = new URLSearchParams(location.search);
      search.value = params.get('guide_q') || ''; format.value = params.get('guide_format') || ''; sort.value = params.get('guide_sort') || 'newest';
      if (!sort.value) sort.value = 'newest';
      page = Math.max(1, Number(params.get('page')) || 1);
      function render(updateUrl = false) {
        const terms = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        const filtered = all.filter(a => (!topic || a.topic === topic) && (!format.value || a.format === format.value) && terms.every(t => `${a.title} ${a.topic} ${a.search}`.toLocaleLowerCase().includes(t)));
        filtered.sort((a,b) => sort.value === 'az' ? a.title.localeCompare(b.title) : sort.value === 'oldest' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date));
        const pages = Math.max(1, Math.ceil(filtered.length / 12)); page = Math.min(page, pages);
        grid.innerHTML = filtered.slice((page-1)*12, page*12).map(a => card(a, labels)).join('');
        root.querySelector('[data-guide-count]').textContent = labels.results.replace('[count]', filtered.length);
        root.querySelector('[data-guide-empty]').hidden = filtered.length !== 0;
        root.querySelectorAll('[data-topic]').forEach(a => {a.classList.toggle('is-active', a.dataset.topic === topic); if(a.dataset.topic === topic) a.setAttribute('aria-current','true'); else a.removeAttribute('aria-current');});
        pagination.replaceChildren();
        const button = (text, target, disabled = false, current = false) => {
          const b = document.createElement('button'); b.type = 'button'; b.textContent = text; b.disabled = disabled;
          if (current) {b.setAttribute('aria-current','page');b.setAttribute('aria-label',labels.page.replace('[number]',target));}
          b.addEventListener('click', () => {page = target; render(true); root.querySelector('#rg-library').scrollIntoView({behavior:'auto',block:'start'}); const link=grid.querySelector('h3 a'); if(link)link.focus({preventScroll:true});});
          pagination.append(b);
        };
        if (pages > 1) {
          button(labels.previous,page-1,page===1);
          const displayed = [...new Set([1,...Array.from({length:5},(_,i)=>page+i-2).filter(n=>n>1&&n<pages),pages])];
          displayed.forEach((n,i) => {if(i && n-displayed[i-1]>1){const gap=document.createElement('span');gap.textContent='…';pagination.append(gap);}button(n,n,false,n===page);});
          button(labels.next,page+1,page===pages);
        }
        if (updateUrl) {
          const active = [...root.querySelectorAll('[data-topic]')].find(a=>a.dataset.topic===topic);
          const u = new URL(active.href); const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if(preview)u.searchParams.set('preview_theme_id',preview);
          if(search.value.trim())u.searchParams.set('guide_q',search.value.trim());
          if(format.value)u.searchParams.set('guide_format',format.value);
          if(sort.value!=='newest')u.searchParams.set('guide_sort',sort.value);
          if(page>1)u.searchParams.set('page',page);
          history.replaceState(null,'',u);
        }
      }
      form.addEventListener('submit',e=>{e.preventDefault();page=1;render(true);});
      let timer; search.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>{page=1;render(true);},180);});
      [format,sort].forEach(el=>{el.disabled=false;el.addEventListener('change',()=>{page=1;render(true);});});
      root.querySelectorAll('[data-topic]').forEach(a=>a.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();topic=a.dataset.topic;page=1;render(true);}));
      root.querySelector('[data-guide-reset]').addEventListener('click',()=>{topic='';search.value='';format.value='';page=1;render(true);});
      render();
    } catch (error) { /* Native topic links, pagination and Shopify search stay available. */ }
  }
  function reading(root) {
    if(root.dataset.initialized)return;root.dataset.initialized='true';
    document.body.classList.add('rg-article-page');
    const body=document.querySelector('.main-article__body'); if(!body)return;
    const labels=JSON.parse(root.querySelector('[data-reading-labels]').textContent);
    const headings=[...body.querySelectorAll('h2,h3')].filter(h=>h.textContent.trim());
    if(headings.length>=3){
      const toc=document.createElement('details');toc.className='rg-toc';
      const summary=document.createElement('summary');summary.textContent=labels.contents;toc.append(summary);
      const list=document.createElement('ol');
      headings.forEach((h,i)=>{if(!h.id)h.id=`rok-guide-heading-${i+1}`;const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);list.append(li);});
      toc.append(list);body.prepend(toc);
    }
    index(root.dataset.blogUrl).then(all=>{
      const related=all.filter(a=>String(a.id)!==root.dataset.articleId&&a.topic===root.dataset.topic).slice(0,3);
      if(!related.length)return;
      const section=document.createElement('section');section.className='rok-guides rg-related';
      const heading=document.createElement('h2');heading.textContent=labels.related;section.append(heading);
      const grid=document.createElement('div');grid.className='rg-grid';grid.innerHTML=related.map(a=>card(a,labels)).join('');section.append(grid);
      document.querySelector('.main-article').closest('.shopify-section').after(section);
    }).catch(()=>{});
  }
  function init(){document.querySelectorAll('[data-rok-guides]').forEach(library);document.querySelectorAll('[data-rok-reading]').forEach(reading);}
  init();document.addEventListener('shopify:section:load',init);
})();
